import React from "react";

import ErrorIcon from "@mui/icons-material/ErrorOutline";
import { Stack } from "@mui/system";

import {
  TableContainerV2,
  TableHeaderV2,
} from "../../Client/Portfolio/shared/shared";
import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  leftTitle: string;
  rightTitle: string;
  errorMessage: string;
}

const ErrorState: React.FC<Props> = (props) => {
  return (
    <TableContainerV2>
      <TableHeaderV2
        leftTitle={props.leftTitle}
        rightTitle={props.rightTitle}
      />
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        style={{
          height: "200px",
          justifyContent: "center",
        }}
      >
        <ErrorIcon color={"info"} fontSize="small" />
        <Text variant="body" color="textSubtle">
          {props.errorMessage}
        </Text>
      </Stack>
    </TableContainerV2>
  );
};

export default ErrorState;
